import * as type from '../mutation-types';

const state = {
    selected: [],
};

const getters = {
    totalSelected(state) {
        return state.selected.length;
    },

    getSelected(state) {
        return state.selected;
    },

    hasSelected(state) {
        return state.selected.length > 0;
    },

    isSelected: state => value => {
        return state.selected.indexOf(value) > -1;
    },
};

const mutations = {
    [type.TOGGLE_SELECTED](state, value) {
        let index = state.selected.indexOf(value);
        if (index > -1) state.selected.splice(index, 1);
        else state.selected.push(value);
    },

    [type.CLEAR_SELECTED](state) {
        state.selected = [];
    },

    [type.TOGGLE_ALL_ROW_SELECTED](state, payload) {
        payload.uniqueKeys.forEach(function(key) {
            if (payload.insert) {
                if (state.selected.indexOf(key) < 0) state.selected.push(key);
            } else {
                let index = state.selected.indexOf(key);
                if (index > -1) state.selected.splice(index, 1);
            }
        });
    },
};

const actions = {
    toogleSelected({ commit }, value) {
        commit(type.TOGGLE_SELECTED, value);
    },

    clearSelected({ commit }, value) {
        commit(type.CLEAR_SELECTED);
    },

    toogleAllRowSelected({ commit }, payload) {
        commit(type.TOGGLE_ALL_ROW_SELECTED, payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
